// v2.5.0 — Route /civ-ai/gps : page livreur authentifiée.
// Gate auth : si sessionStorage.courier_token absent → CourierLoginScreen.
// Si présent → DeliveryPage (Mapbox 3D) + bandeau livreur en haut.

import { useEffect, useState } from "react";
import { toast } from "sonner";
import CourierLoginScreen from "../components/CourierLoginScreen";
import DeliveryPage from "./DeliveryPage";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function GpsCourierPage() {
  const [company, setCompany] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = sessionStorage.getItem("courier_token");
    if (!token) {
      setChecking(false);
      return;
    }
    // Re-valide le token côté backend (utile si fichier rechargé / token révoqué).
    fetch(`${API}/courier/me`, { headers: { "x-courier-token": token } })
      .then((r) => r.json().then((d) => ({ ok: r.ok, d })))
      .then(({ ok, d }) => {
        if (ok && d.ok && d.company) {
          setCompany(d.company);
          sessionStorage.setItem("courier_company", JSON.stringify(d.company));
        } else {
          sessionStorage.removeItem("courier_token");
          sessionStorage.removeItem("courier_company");
        }
      })
      .catch(() => {
        // Erreur réseau : on garde le token et on fait confiance au cache local.
        const cached = sessionStorage.getItem("courier_company");
        if (cached) {
          try { setCompany(JSON.parse(cached)); } catch (_) {}
        }
      })
      .finally(() => setChecking(false));
  }, []);

  const onAuthSuccess = (c) => setCompany(c);

  const logout = () => {
    sessionStorage.removeItem("courier_token");
    sessionStorage.removeItem("courier_company");
    setCompany(null);
    toast.success("Déconnecté");
  };

  if (checking) {
    return (
      <div data-testid="courier-gate-loading" style={{
        position: "fixed", inset: 0, display: "flex", alignItems: "center", justifyContent: "center",
        background: "#0F172A", color: "#fff", fontFamily: "system-ui",
      }}>
        <div>Vérification de la session livreur…</div>
      </div>
    );
  }

  if (!company) {
    return <CourierLoginScreen onAuthSuccess={onAuthSuccess} />;
  }

  return (
    <div data-testid="gps-courier-page" style={{ position: "fixed", inset: 0 }}>
      <DeliveryPage />
      {/* Bandeau livreur — overlay en haut-centre */}
      <div data-testid="courier-banner" style={{
        position: "fixed", top: 16, left: "50%", transform: "translateX(-50%)",
        background: "rgba(15,23,42,0.92)", color: "#fff",
        padding: "8px 16px", borderRadius: 999, fontSize: 13, fontWeight: 600,
        border: "1px solid rgba(255,255,255,0.18)", boxShadow: "0 6px 18px rgba(0,0,0,0.4)",
        backdropFilter: "blur(10px)", zIndex: 10, display: "flex", alignItems: "center", gap: 10,
      }}>
        <span data-testid="courier-banner-company">
          Connecté en tant que {company.logo_emoji} <strong>{company.name}</strong>
        </span>
        <button
          type="button"
          onClick={logout}
          data-testid="courier-logout"
          style={{
            background: "rgba(220,38,38,0.85)", color: "#fff", border: "none",
            padding: "4px 10px", borderRadius: 999, cursor: "pointer", fontSize: 11, fontWeight: 600,
          }}
        >
          Déconnexion
        </button>
      </div>
    </div>
  );
}
